import { render } from "./YButton.vue?vue&type=template&id=3205cc21&scoped=true"
import script from "./YButton.vue?vue&type=script&lang=js"
export * from "./YButton.vue?vue&type=script&lang=js"

import "./YButton.vue?vue&type=style&index=0&id=3205cc21&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/线上短信平台/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3205cc21"]])

export default __exports__